import { GlobalVariables } from '../GlobalVariables';

export default class BlockGeographicLocationMap {
	static init() {
		this.blockEl = document.querySelector(".block-geographic-location-map");

		if (!this.blockEl) {
			return;
		}

		this.locations = [ ...this.blockEl.querySelectorAll(".location") ];
		this.SVGRegionsGroups = [ ...this.blockEl.querySelectorAll('.map-container svg [data-region]') ];

		if (GlobalVariables.isMobile) {
			this.addMobileListeners();
		} else {
			this.addDesktopListeners();
		}
	}

	static addMobileListeners = () => {
		this.blockEl.addEventListener('click', ({ target }) => {
			const node = target.nodeName.toLowerCase();

			// remove any previous active region
			this.setActive({
				els: [ ...this.locations, ...this.SVGRegionsGroups ],
				toggle: false
			});

			// if the target is not an address of the list or a path of the map, return early
			if (node !== 'li' && node !== 'path') {
				return;
			}

			let region = null;

			if (node === 'path') {
				// data-region is stored on the parent `<g>` element
				region = target.parentElement.getAttribute('data-region');
			} else {
				region = target.getAttribute('data-region');
			}

			if (!region) {
				return;
			}

			this.setActive({
				els: [ ...this.blockEl.querySelectorAll(`[data-region='${region}']`) ],
				toggle: true,
			});
		});
	};

	static addDesktopListeners = () => {
		this.locations.forEach((location) => {
			const { region } = location.dataset; // region number/identifier
			// get the SVG group that has the same region number/identifier as the location of the address list
			const [ locationSVGRegion ] = this.SVGRegionsGroups.filter((reg) => reg.getAttribute('data-region') === region);

			// Handle hover styling for both the location cards and the SVG map regions
			[ location, locationSVGRegion ].forEach((el) => {
				el.addEventListener('mouseenter', () => {
					this.setActive({ els: [ location, locationSVGRegion ], toggle: true });
				});

				el.addEventListener('mouseleave', () => {
					this.setActive({ els: [ location, locationSVGRegion ], toggle: false });
				});
			});

			// keyboard navigation
			location.addEventListener('focusin', (e) => {
				this.setActive({ els: [ location, locationSVGRegion ], toggle: true });
			});

			location.addEventListener('focusout', (e) => {
				this.setActive({ els: [ location, locationSVGRegion ], toggle: false });
			});
		});
	};

	/**
	 * @param options
	 * @param options.els {(HTMLElement|SVGElement)[]}
	 * @param options.toggle {boolean}
	 */
	static setActive = ({ els: [ ...els ], toggle }) => {
		els.forEach((el) => {
			el.classList.toggle('active', toggle);
		});
	};
}